function printPageDirective($window, $timeout) {
    'ngInject';

    return {
        restrict: 'A',
        link(scope, element, attr) {
            if (attr.bbPrintPage) {
                scope.$watch(attr.bbPrintPage, (newVal, oldVal) => {
                    return $timeout(() => $window.print(),
                        3000);
                });
            }
        }
    };
}

angular
    .module('BB')
    .directive('bbPrintPage', printPageDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/print-page/print_page.directive.js